import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { AppRoutes } from '@ciptech/constants'

@Injectable()
export class RolGuard implements CanActivate, CanLoad {

	constructor(
		private session: SessionService,
		private router: Router
	) {
	}

	private checkRole(rols: any, returnUrl?: string): boolean | UrlTree {
		const user = this.session.user;

		if (!user) {
			return this.router.createUrlTree([AppRoutes.SIGN_IN], {
				queryParams: returnUrl ? { returnUrl } : undefined
			});
		}

		if (!user.hasRole(rols)) {
			return this.router.createUrlTree([AppRoutes.NOT_FOUND]);
		}

		return true;
	}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
		return this.checkRole(next.data.rols, state.url);
	}

	canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
		const url = '/' + segments.map(s => s.path).join('/');
		return this.checkRole(route.data?.rols, url);
	}

}
